// Lightweight activity tracking
const ACCOUNT_API = 'https://563t3yrmw5d42zyd7gw6eeeun40htlid.lambda-url.us-east-1.on.aws';

export const trackActivity = async (type, page = '', metadata = {}) => {
  try {
    const token = localStorage.getItem('idToken');
    if (!token) return;
    
    await fetch(`${ACCOUNT_API}/api/account/activity`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
      body: JSON.stringify({ type, page, metadata })
    });
  } catch (e) {
    // Silent fail - don't block user experience
  }
};

export const trackLogin = () => trackActivity('login');
export const trackPageView = (page) => trackActivity('page_view', page);
export const trackPickViewed = (pickId) => trackActivity('pick_viewed', '', { pick_id: pickId });
export const trackBetAdded = (matchup) => trackActivity('bet_added', '', { matchup });
export const trackChatMessage = (queryLength) => trackActivity('chat_message', '', { query_length: queryLength });
